export default __webpack_public_path__ + "static/media/26.60b29a0f.jpg";